import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { PagedResultOfUserInfo, QueryParametersOfUserListFilter, UserApi, UserInfo, UserListFilter } from 'src/app/core/api.gen';
import { DialogService } from 'src/app/core/dialog.service';
import { LoaderService } from 'src/app/core/loader.service';

@Component({
  selector: 'eos-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  queryParams = new QueryParametersOfUserListFilter();
  data = new PagedResultOfUserInfo();

  currentPage: number = 1;
  totalRecords: number = 0;
  totalPages: number = 0;
  changeCount: number[] = [10, 15, 25, 50, 75];
  pages: number[] = [];
  tableLoading = true;
  pageNumber = 1;

  constructor(
    private userAPI: UserApi,
    private dialogService: DialogService,
    private loader: LoaderService,
  ) { }

  ngOnInit() {
    this.queryParams.init({
      page: 1,
      itemsPerPage: 10,
      sortBy: 'name',
      reverse: false,
      filterParams: new UserListFilter()
    });

    this.reloadData();
  }

  gridConfigure() {

    this.currentPage = this.data ? (this.data.page ?? 1) : 1;
    this.totalRecords = this.data ? (this.data.totalRecords ?? 0) : 0;
    this.numberOfPages();
    this.pageGenerate();

  }

  reloadData() {
    this.loader.show();
    this.userAPI.getUsers(this.queryParams).pipe(finalize(() => {
      this.loader.clear();
    })).subscribe(result => {
      this.data = result;
      this.gridConfigure();
    });

  }

  onSearch() {
    this.reloadData();
  }

  onClear() {
    this.queryParams.filterParams = new UserListFilter();
    this.reloadData();
  }

  sort(reverse: boolean, prop: string) {
    this.queryParams.reverse = reverse;
    this.queryParams.sortBy = prop;

    this.reloadData();
  }

  addUser() {
    this.dialogService.showUserEdit(new UserInfo(), "Add user", () => this.reloadData());
  }

  editUser(user: UserInfo) {
    this.dialogService.showUserEdit(user, "Edit user", () => this.reloadData());
  }

  pageChange(page: number) {

    if (page > this.totalPages || page <= 0) {
      this.pageNumber = page > this.totalPages ? this.totalPages : 1;
      return;
    }

    if ((page === this.pageNumber + 4) && !((page + 4) > this.totalPages)) {
      this.pageNumber = this.pageNumber + 4;
    } else if ((page === this.pageNumber) && (page - 4) > 0) {
      this.pageNumber = this.pageNumber - 4;
    } else if ((page === this.pageNumber + 4) && ((page + 4) > this.totalPages)) {
      this.pageNumber = this.pageNumber + (this.totalPages - page);
    } else if ((page === this.pageNumber) && (page - 4) < 1) {
      this.pageNumber = 1;
    } else if ((page < this.pageNumber) && (this.pageNumber - 4) > 0) {
      this.pageNumber = this.pageNumber - 4;
    } else if ((page > this.pageNumber + 4) && (page + 4) <= this.totalPages) {
      this.pageNumber = page;
    } else if ((page > this.pageNumber + 4) && (page + 4) > this.totalPages) {
      this.pageNumber = page - ((page + 4) - this.totalPages);
    }

    if (page === 1) {
      this.pageNumber = 1;
    }

    this.queryParams.page = page;
    this.currentPage = page;
    this.reloadData();
  }

  onSelectChanges() {
    if (this.currentPage > this.numberOfPages()) {
      this.queryParams.page = this.numberOfPages();
    }
    this.queryParams.itemsPerPage = this.data.itemsPerPage;
    this.reloadData();
  }

  numberOfPages() {
    this.totalPages = this.data && this.data.totalRecords !== undefined && this.data.itemsPerPage !== undefined && this.data.itemsPerPage > 0
      ? Math.ceil(this.data.totalRecords / this.data.itemsPerPage)
      : 0;

    return this.totalPages;
  }

  pageGenerate() {
    this.pages = [];

    for (let i = 0; i < (this.totalPages > 5 ? 5 : this.totalPages); i++) {
      this.pages.push(i);
    }

    if (this.totalPages <= 5) {
      this.pageNumber = 1;
    } else if (this.currentPage - 4 > 0) {
      this.pageNumber = this.currentPage - 4;
    }
  }

}
